import app from 'flarum/forum/app';
import on from './gate';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import RequestSong from './RequestSong';
import startChallenge from './startChallenge';
export default class LearnIndexPage extends Page {
  songs = [];
  waiting = [];
  sort = 'popular';
  loading = true;
  error = '';
  sequence = 0;
  oninit(v) {
    super.oninit(v);
    if (!on()) return;
    app.setTitle('Learn a song');
    this.sort = m.route.param('sort') === 'newest' ? 'newest' : 'popular';
    this.load();
    if (app.session.user?.isAdmin()) app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/challenges/songs',
      errorHandler: () => {}
    }).then(r => {
      this.waiting = r.data.filter(s => s.requested && s.status === 'ready' && !s.approved);
      m.redraw();
    }).catch(() => {});
  }
  load() {
    if (!on()) return;
    const seq = ++this.sequence;
    this.loading = true;
    this.error = '';
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/challenges/catalog',
      params: {
        sort: this.sort
      }
    }).then(r => {
      if (seq === this.sequence) this.songs = r.data;
    }).catch(() => this.error = 'Could not load the library. Try again.').finally(() => {
      if (seq === this.sequence) this.loading = false;
      m.redraw();
    });
  }
  view() {
    if (!on()) return null;
    return m(PageStructure, {
      className: "Challenges-index",
      sidebar: () => m(IndexSidebar, null)
    }, m("div", {
      className: "LearnIndex"
    }, !!this.waiting.length && m("section", {
      className: "Learn-request"
    }, m("h2", null, "Requested songs waiting for review"), m("p", null, "Open each page, check it, then press Approve. The member who asked gets a notification."), m("ul", null, this.waiting.map(song => m("li", {
      key: song.id
    }, m(Link, {
      href: app.route('challenges.learn', {
        slug: song.slug
      })
    }, song.track, " \u2013 ", song.artist), " ", m("small", null, song.album, " \xB7 ", song.year))))), m("header", {
      className: "Learn-indexHero"
    }, m("span", {
      className: "Learn-eyebrow"
    }, "GuitarTalk \xB7 Learn together"), m("h1", null, "Learn a song"), m("p", null, "Pick your next song. Find the lessons, make a plan, and share your progress over 30 days.")), m("div", {
      className: "Learn-tabs",
      role: "tablist",
      "aria-label": "Sort Learn pages"
    }, [['popular', 'Most learned this month'], ['newest', 'Newest']].map(_ref => {
      let [sort, label] = _ref;
      return m(Button, {
        role: "tab",
        "aria-selected": this.sort === sort,
        className: 'Button ' + (this.sort === sort ? 'Learn-tab--active' : ''),
        onclick: () => {
          this.sort = sort;
          this.load();
        }
      }, label);
    })), this.error && m("p", {
      role: "alert"
    }, this.error), this.loading && !this.songs.length && m("p", {
      role: "status"
    }, "Loading the library\u2026"), m("div", {
      className: "Learn-grid"
    }, this.songs.map(song => m("article", {
      className: "Learn-tile",
      key: song.id
    }, m(Link, {
      className: "Learn-tile-link",
      href: app.route('challenges.learn', {
        slug: song.slug
      })
    }, m("div", {
      className: "Learn-tile-art"
    }, song.image_url && m("img", {
      src: song.image_url,
      alt: "",
      loading: "lazy"
    }), m("span", {
      className: "Learn-count"
    }, m("span", {
      "aria-hidden": "true"
    }, "\u25CF"), " ", song.active_count, " learning now")), m("div", {
      className: "Learn-tile-info"
    }, m("h2", null, song.track), m("p", null, song.artist), m("small", null, song.album, " \xB7 ", song.year))), m(Button, {
      className: "Button Learn-start",
      onclick: () => startChallenge(song)
    }, "Start a challenge with this song ", m("span", {
      "aria-hidden": "true"
    }, "\u2192"))))), !this.loading && !this.error && !this.songs.length && m("p", null, "The first Learn pages are on their way. Request a song below."), m(RequestSong, null)));
  }
}